import { Component, OnInit } from '@angular/core';

import { OptionProperty } from '../../types/control.types';
import { AbstractPropertyEditorBase } from '../../types/property-editor.types';
import { AbstractValueControlBase } from '../../types/abstract-value-control-base';
import { ValueControlViewModel } from '../../types';

@Component({
  selector: 'df-cascade-property-editor',
  templateUrl: './cascade-property-editor.component.html',
  styleUrls: ['./cascade-property-editor.component.css']
})
export class CascadePropertyEditorComponent extends AbstractPropertyEditorBase implements OnInit {
  tabsData: Array<OptionProperty>;
  choice?: number = 0;

  set tabValue(val: any) {
    this._tabValue = val;
    this.memberSetting.disabled = !this._tabValue;
  }
  get tabValue(): any {
    return this._tabValue;
  }

  memberSetting = { maxlength: 50, reg: /^[A-Za-z]+[A-Za-z0-9]*$/, disabled: true };

  displayMember: string;
  valueMember: string;

  control: AbstractValueControlBase<ValueControlViewModel<any>>;

  private _tabValue: string;

  constructor() {
    super();
  }

  ngOnInit() {}

  get showSetMember(): boolean {
    return this.choice === 1;
  }

  selectedItem(event: any) {
    this.tabsData.forEach((item: OptionProperty, index) => {
      if (event.id === item.id) {
        item.selected = true;
        this.choice = index;
        this.tabValue = item.value;
        this.displayMember = item.displayMember;
        this.valueMember = item.valueMember;
      } else {
        item.selected = false;
      }
    });
  }

  afterControlValueInit() {
    this.tabsData = this.value;
    this.defaultSelection();
  }

  defaultSelection() {
    if (!this.tabsData) {
      this.tabsData = [
        { text: 'ä¸çº§åç§°', id: 'custom', selected: true, value: '' },
        { text: 'æ°æ®æº', id: 'dataSource', selected: false, value: '' }
      ];
    }
    this.selectedItem(this.tabsData.filter((s: OptionProperty) => s.selected === true)[0]);
    this.setTabValue();
  }

  setTabValue() {
    // è®¾ç½®æ°æ®
    const tabsData = JSON.parse(JSON.stringify(this.tabsData));
    tabsData[this.choice].value = this.tabValue;
    tabsData[this.choice].displayMember = this.displayMember;
    tabsData[this.choice].valueMember = this.valueMember;
    this.afterSetControlValue(tabsData);
    this.tabsData = this.control.model.cascadeParentName;
    this.tabValue = this.tabsData[this.choice].value;
    this.displayMember = this.tabsData[this.choice].displayMember;
    this.valueMember = this.tabsData[this.choice].valueMember;
  }
}
